export class InvoiceForwardModel {
    public TargetGroupId: number;

    public Comment: string;
}